import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointsQrCodeCellProps
  extends CellContext<GatewayChargePointInMaintenanceModel, unknown> {}

export const ChargePointsQrCodeCell = (
  props: ChargePointsQrCodeCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const {
    row: { original: chargePoint },
  } = props;
  const { channels } = chargePoint;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.XS} direction="column">
      {channels.map((channel) => (
        <Text truncate key={channel.id}>
          {channel.qrCode ?? '-'}
        </Text>
      ))}
    </Stack>
  );
};
